import API from "../../../api.js";
import {
  APPOINTMENT_CREATE_REQUEST,
  APPOINTMENT_CREATE_SUCCESS,
  APPOINTMENT_CREATE_FAIL,
  APPOINTMENT_LIST_REQUEST,
  APPOINTMENT_LIST_SUCCESS,
  APPOINTMENT_LIST_FAIL,
} from "../../constants/patientConstants/appointmentConstants.js";

export const createAppointment = (appointmentData) => async (dispatch) => {
  try {
    dispatch({ type: APPOINTMENT_CREATE_REQUEST });
    const { data } = await API.post("/patient/appointments", appointmentData);
    dispatch({ type: APPOINTMENT_CREATE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: APPOINTMENT_CREATE_FAIL,
      payload: error.response?.data?.msg || error.message,
    });
  }
};

export const listAppointments = () => async (dispatch) => {
  try {
    dispatch({ type: APPOINTMENT_LIST_REQUEST });
    const { data } = await API.get("/patient/appointments");
    dispatch({ type: APPOINTMENT_LIST_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: APPOINTMENT_LIST_FAIL,
      payload: error.response?.data?.msg || error.message,
    });
  }
};
